import { z } from 'zod';
const same = (name) => ({ en: name, pt: name, ru: name });
export const PROTOCOL_SECTIONS = [
    {
        id: 'cleansing',
        multi: false,
        title: { en: 'Cleansing', pt: 'Limpeza', ru: 'Очищение' },
        client: false,
        options: [
            { id: 'gel-pure-academie', label: same('Gel Pure by Academie') },
            { id: 'gel-vitc-academie', label: same('Gel with vit C by Academie') },
            { id: 'enzyme-powder', label: { en: 'Enzyme powder/gel', pt: 'Pó/gel enzimático', ru: 'Энзимная пудра/гель' } },
        ],
    },
    {
        id: 'tonic',
        multi: false,
        title: { en: 'Lotion / Tonique', pt: 'Loção / Tónico', ru: 'Лосьон / тоник' },
        client: false,
        options: [
            { id: 'normalizing-toner-academie', label: same('Normalizing toner by Academie') },
            { id: 'lotion-vitc-academie', label: same('Lotion tonic Vit. C Academie') },
            { id: 'lotion-hypo-academie', label: same('Lotion Hypo-Sensible by Academie') },
        ],
    },
    {
        id: 'massage_cream',
        multi: false,
        title: { en: 'Face massage cream', pt: 'Creme de massagem', ru: 'Крем для массажа' },
        client: false,
        options: [
            { id: 'ellevon-collagen', label: same('Ellevon collagen / Vita balance') },
            { id: 'oil-free', label: { en: 'Oil free', pt: 'Sem óleo', ru: 'Без масла' } },
            { id: 'vite-cotton', label: same('Vit. E and Cotton') },
        ],
    },
    {
        id: 'finishing',
        multi: true,
        title: { en: 'Finishing products', pt: 'Produtos de finalização', ru: 'Финишные средства' },
        client: false,
        options: [
            { id: 'cream-radiance', label: same('Cream Radiance') },
            { id: 'cream-hypo-sensitive', label: same('Cream Hypo Sensitive') },
            { id: 'cream-pure-renovatrice', label: same('Cream Pure Renovatrice') },
            { id: 'mist-dalba', label: same("Mist D'Alba") },
            { id: 'anti-redness', label: { en: 'Anti-redness', pt: 'Anti-vermelhidão', ru: 'Против покраснений' } },
            { id: 'face-cream-hl', label: same('Face cream HL lab') },
        ],
    },
    {
        id: 'extra_used',
        multi: true,
        title: { en: 'Extra products used', pt: 'Produtos extra', ru: 'Доп. средства' },
        client: false,
        options: [
            { id: 'super-lotion-hl', label: same('Super Lotion by HL lab') },
            { id: 'gommage', label: same('Gommage') },
            { id: 'youth-lift', label: same('Face / Eye Youth Lift') },
            { id: 'lip-balm-3d', label: same('Lip balm — 3D Lift') },
        ],
    },
    {
        id: 'attention',
        multi: true,
        title: { en: 'What we noticed', pt: 'O que notámos', ru: 'На что обратили внимание' },
        client: true,
        options: [
            { id: 'jaw-tension', label: { en: 'Jaw tension', pt: 'Tensão no maxilar', ru: 'Напряжение в челюсти' } },
            { id: 'swelling', label: { en: 'Swelling', pt: 'Inchaço', ru: 'Отёчность' } },
            {
                id: 'eye-area',
                label: { en: 'Dark circles / eye area', pt: 'Olheiras / zona dos olhos', ru: 'Тёмные круги / зона глаз' },
            },
            { id: 'neck-tension', label: { en: 'Neck tension', pt: 'Tensão no pescoço', ru: 'Напряжение в шее' } },
            { id: 'dry-skin', label: { en: 'Dry skin', pt: 'Pele seca', ru: 'Сухая кожа' } },
            { id: 'pigmentation', label: { en: 'Pigmentation', pt: 'Pigmentação', ru: 'Пигментация' } },
            { id: 'temples-tension', label: { en: 'Temples tension', pt: 'Tensão nas têmporas', ru: 'Напряжение в висках' } },
        ],
    },
    {
        id: 'services',
        multi: true,
        title: { en: 'Treatments we suggest', pt: 'Tratamentos que sugerimos', ru: 'Рекомендуем процедуры' },
        client: true,
        options: [
            { id: 'buccal', label: { en: 'Buccal massage', pt: 'Massagem bucal', ru: 'Буккальный массаж' } },
            { id: 'head-massage', label: { en: 'Head massage', pt: 'Massagem de cabeça', ru: 'Массаж головы' } },
            { id: 'head-shoulders', label: { en: 'Head and shoulders', pt: 'Cabeça e ombros', ru: 'Голова и плечи' } },
            {
                id: 'peeling',
                label: { en: 'Peeling / pore cleansing', pt: 'Peeling / limpeza de poros', ru: 'Пилинг / чистка пор' },
            },
            { id: 'drainage', label: { en: 'Drainage', pt: 'Drenagem', ru: 'Дренаж' } },
            { id: 'led', label: same('LED therapy') },
            { id: 'ems', label: { en: 'Microcurrent / EMS', pt: 'Microcorrente / EMS', ru: 'Микротоки / EMS' } },
            { id: 'eye-treatment', label: { en: 'Eye treatment', pt: 'Tratamento de olhos', ru: 'Уход за зоной глаз' } },
            { id: 'hydration', label: { en: 'Hydration', pt: 'Hidratação', ru: 'Увлажнение' } },
            { id: 'co2', label: { en: 'CO2 therapy (gel)', pt: 'Terapia CO2 (gel)', ru: 'CO2-терапия (гель)' } },
        ],
    },
];
const ALL_OPTION_IDS = new Set(PROTOCOL_SECTIONS.flatMap((s) => s.options.map((o) => o.id)));
export const ProtocolSchema = z.object({
    /** Option ids picked in any section. */
    picked: z
        .array(z.string())
        .max(60)
        .default([])
        .refine((ids) => ids.every((id) => ALL_OPTION_IDS.has(id)), 'unknown protocol option'),
    /** The free fields of the paper form (studio only). */
    faceMask: z.string().trim().max(80).optional(),
    ampoule: z.string().trim().max(80).optional(),
    other: z.string().trim().max(200).optional(),
    treatmentType: z.string().trim().max(80).optional(),
});
/** The client-facing part: picked options of the `client` sections, by section, in the given language. */
export function protocolForClient(p, lang = 'en') {
    if (!p)
        return [];
    return PROTOCOL_SECTIONS.filter((s) => s.client)
        .map((s) => ({
        section: s.id,
        title: s.title[lang],
        items: s.options.filter((o) => p.picked.includes(o.id)).map((o) => o.label[lang]),
    }))
        .filter((s) => s.items.length > 0);
}
//# sourceMappingURL=protocol.js.map